import { createTheme } from '@material-ui/core';
import { MuiThemeProvider } from '@material-ui/core/styles';
import React from 'react';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import AppContent from './components/main/AppContent';
import { store } from './reducers';


const theme = createTheme({
    palette: {
        primary: {
            main: '#3D7A96',
        },
        secondary: {
            main: '#f44336',
        },
        error: {
            main: '#e73e33',
        },
    },
});


class App extends React.Component {

    getFaviconEl() {
        return document.getElementById("favicon");
    }

    componentDidMount()
    {
       const location = window.location.origin;

       if(location.includes("dev") || location.includes("staging"))
       {
           this.getFaviconEl().href = `${location}/devStagingfavicon.ico`
       }

    }

    state = {
        // headerHeight: 64,

    };

    render() {
        return (
            <Provider store={store}>
                <BrowserRouter >
                    <MuiThemeProvider theme={theme}>
                        {/* <AppInfoContext.Provider value={this.state.headerHeight}> */}
                            <AppContent />
                        {/* </AppInfoContext.Provider>                     */}
                    </MuiThemeProvider>
                </BrowserRouter>
            </Provider>


        );
    }
}

export default App;